import React, { useEffect, useMemo } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider
} from "react-bootstrap-table2-paginator";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../_redux/organization-feature/organizationFeatureAction";
import * as uiHelpers from "../OrganizationFeatureUIHelpers";
import { ActionsColumnFormatter } from "./column-formatters";
import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage
} from "../../../../../../_metronic/_helpers";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import { useOrganizationFeatureUIContext } from "../OrganizationFeatureUIContext";
import { RoleChecker } from "../../../../../RoleChecker";

const OrganizationFeatureTable = ({ allowEdit }) => {
  // OrganizationFeature UI Context
  const organizationFeatureUIContext = useOrganizationFeatureUIContext();
  const organizationFeatureUIProps = useMemo(() => {
    return {
      queryParams: organizationFeatureUIContext.queryParams,
      setQueryParams: organizationFeatureUIContext.setQueryParams,
      openEditOrganizationFeaturePage:
        organizationFeatureUIContext.openEditOrganizationFeaturePage
    };
  }, [organizationFeatureUIContext]);

  // Getting curret state of organizationFeature list from store (Redux)
  const { currentState } = useSelector(
    state => ({ currentState: state.organizationFeatures }),
    shallowEqual
  );

  const { totalCount, entities, listLoading } = currentState;

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      actions.findOrganizationFeatures(organizationFeatureUIProps.queryParams)
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organizationFeatureUIProps.queryParams, dispatch]);

  // Table columns
  const columns = [
    {
      dataField: "name",
      text: "Nama Lembaga"
    },
    {
      dataField: "active_features",
      text: "Fitur Aktif",
      formatter: (_, { organization_features }) => {
        const active_features = (organization_features ?? []).filter(
          ({ is_active }) => is_active
        );
        // let features =
        //   (organization_features instanceof Array && organization_features) ||
        //   [];

        // const settle = features.find(({ name }) => name === "SETTLE");
        // const {is_active} = settle ?? {}

        // return (
        //   <div className={`badge ${badge}`}></div>
        // );

        return (
          <ul>
            {active_features.map(({ uuid, name }) => (
              <li key={uuid}>{name}</li>
            ))}
          </ul>
        );
      }
    },
    {
      dataField: "inactive_features",
      text: "Fitur Tidak Aktif",
      formatter: (_, { organization_features }) => {
        const active_features = (organization_features ?? []).filter(
          ({ is_active }) => !is_active
        );

        return (
          <ul>
            {active_features.map(({ uuid, name }) => (
              <li key={uuid}>{name}</li>
            ))}
          </ul>
        );
      }
    },
    {
      dataField: "",
      text: "Actions",
      formatter: ActionsColumnFormatter,
      formatExtraData: {
        openEditOrganizationFeaturePage:
          organizationFeatureUIProps.openEditOrganizationFeaturePage,
        allowEdit
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-3",
      style: {
        minWidth: "100px"
      }
    }
  ];

  // Table pagination properties
  // ? Disable pagination temporarily
  // const paginationOptions = {
  //   custom: true,
  //   totalSize: totalCount,
  //   sizePerPageList: uiHelpers.sizePerPageList,
  //   sizePerPage: organizationFeatureUIProps.queryParams.pageSize,
  //   page: organizationFeatureUIProps.queryParams.pageNumber
  // };

  return (
    <>
      <BootstrapTable
        wrapperClasses="table-responsive"
        classes="table table-head-custom table-vertical-center overflow-hidden"
        bootstrap4
        bordered={false}
        remote
        keyField="uuid"
        data={entities === null ? [] : entities}
        columns={columns}
        // ? Disable pagination temporarily
        // defaultSorted={uiHelpers.defaultSorted}
        // onTableChange={getHandlerTableChange(
        //   organizationFeatureUIProps.setQueryParams
        // )}
        // {...paginationTableProps}
      >
        <PleaseWaitMessage entities={entities} />
        <NoRecordsFoundMessage entities={entities} />
      </BootstrapTable>
      {/* <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              isLoading={listLoading}
              paginationProps={paginationProps}
            >
              
            </Pagination>
          );
        }}
      </PaginationProvider> */}
    </>
  );
};

export default OrganizationFeatureTable;
